<template>
  <section class="editor-block">
    <div class="block-head">
      <span class="eyebrow">Media</span>
      <strong>本地图片上传</strong>
    </div>
    <div class="upload-grid">
      <button class="upload-card" type="button" @click="triggerImageSelect('backgroundImg')">
        <span>背景图</span>
        <strong>{{ editForm.backgroundImg ? '已选择' : '选择本地图片' }}</strong>
        <small>{{ uploadingField === 'backgroundImg' ? '上传中...' : '用于详情和实时预览背景' }}</small>
      </button>
      <button class="upload-card" type="button" @click="triggerImageSelect('img')">
        <span>封面图</span>
        <strong>{{ editForm.img ? '已选择' : '选择本地图片' }}</strong>
        <small>{{ uploadingField === 'img' ? '上传中...' : '用于档案卡片封面' }}</small>
      </button>
    </div>
    <input ref="backgroundInputRef" class="file-input" type="file" accept="image/*" @change="handleFileChange($event, 'backgroundImg')" />
    <input ref="coverInputRef" class="file-input" type="file" accept="image/*" @change="handleFileChange($event, 'img')" />
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { ImageField, LevelItem } from './types';

defineProps<{
  editForm: Partial<LevelItem>;
  uploadingField: '' | ImageField;
}>();

const emit = defineEmits<{
  (e: 'imageFile', field: ImageField, file: File): void;
}>();

const backgroundInputRef = ref<HTMLInputElement>();
const coverInputRef = ref<HTMLInputElement>();

const triggerImageSelect = (field: ImageField) => {
  if (field === 'backgroundImg') backgroundInputRef.value?.click();
  else coverInputRef.value?.click();
};

const handleFileChange = (event: Event, field: ImageField) => {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0];
  input.value = '';
  if (file) emit('imageFile', field, file);
};
</script>
